import { render, staticRenderFns } from "./reading-durations.vue?vue&type=template&id=6ab996e1&scoped=true&"
import script from "./reading-durations.vue?vue&type=script&lang=js&"
export * from "./reading-durations.vue?vue&type=script&lang=js&"
import style0 from "./reading-durations.vue?vue&type=style&index=0&id=6ab996e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab996e1",
  null
  
)

export default component.exports